import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import ListeningRoute from '../ListeningRoute';

function getCurrentQuestionnaireName() {
  // "/questionnaire/DTT/group/A"
  const pathName = window.location.pathname;
  const questionnaireName = pathName.split("/")[2];
  return questionnaireName;
}

const Prop = {
  data: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
};

// header Route to update the url
// URLGroup gets the letter at the end of the url that's loaded with the section
const HeaderRoute = ({ data, ...rest }) => {
  const questionnaireName = getCurrentQuestionnaireName();
  return (
    <ListeningRoute
      path={`/questionnairePage/${questionnaireName}/group/${data.linkId}`}
      data={data}
      render={props => (
        <HeaderTitle
          {...props}
          data={data}
          URLGroup={window.location.href.split('/').pop()}
          {...rest}
        />
      )}
    />
  );
};

// logic to display header title if section letter = section questions displayed
const HeaderTitle = ({ data, URLGroup }) =>
  (data.linkId === URLGroup ? (
    <React.Fragment>
      <Row>
        <Col>
          <p className="display-4" align="center">
            {data.text}
          </p>
        </Col>
      </Row>
    </React.Fragment>
  ) : null);

// logic to check if the data being looked at is a group (if yes then proceed to make a header)
const Item = ({ data }) =>
  (data.type === 'group' ? <HeaderRoute data={data} /> : null);

// if data has an item (array of questions) then map it to Item
const Header = ({ data = { item: [] } }) => (
  <Container fluid>
    {data.item
      ? data.item.map(item => <Item key={item.linkId} data={item} />)
      : null}
  </Container>
);

// Proptypes
Item.propTypes = Prop;
HeaderTitle.propTypes = {
  URLGroup: PropTypes.string,
  ...Prop,
}.isRequired;
Header.propTypes = Prop;
HeaderRoute.propTypes = Prop;

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js